export default "__VITE_ASSET__B2QiX1aj__"